module.exports = __webpack_public_path__ + "img/mind_skeleton_3.68bc19dc.png";